import React from 'react'
import './style.scss'
import './disposable.scss'

import ACFImage from './Image'
import ACFVideo from './Video'
import ACFWYSIWYG from './WYSIWYG'
import ACFCustom from './Custom'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

// Slider settings
const sliderSettings = {
	dots: true,
	arrows: true,
	infinite: true,
	speed: 800,
	pauseOnFocus: true,
	autoplay: false,
	autoplaySpeed: 8000,
	slidesToShow: 1,
	slidesToScroll: 1,
	accessibility: false,
	fade: true,
	focusOnSelect: true,
	adaptiveHeight: false,
	centerMode: false,
	variableWidth: false
}

// random.ts
function randomId(){

	if (typeof window !== 'undefined') {
		const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0]
		return uint32.toString(16)
	}
}

// Main
function ACFBlocks(props) {

	// Create Building Blocks
	function createBlocks(node) {

		// Main Settings
		const anchor = node.anchor
		const classes = node.classes
		let layout = null
		if (node.acf_fc_layout) {
			layout = node.acf_fc_layout
		} else {
			switch (node.fieldGroupName) {
				case 'Academic_Pagebuilder_Sections_Content_Block_Wysiwyg':
					layout = 'wysiwyg'
					break
				case 'Academic_Pagebuilder_Sections_Content_Block_Custom':
					layout = 'custom'
					break
				case 'Academic_Pagebuilder_Sections_Content_Block_Image':
					layout = 'image'
					break
				case 'Academic_Pagebuilder_Sections_Content_Block_Map':
					layout = 'map'
					break
				case 'Academic_Pagebuilder_Sections_Content_Block_Slide':
					layout = 'slide'
					break
				case 'Academic_Pagebuilder_Sections_Content_Block_Video':
					layout = 'video'
					break
			}
		}

		const random_id = randomId()

		// Returning Block
		return (
			<div key={node.id ? node.id : random_id} id={anchor ? 'block-' + anchor : null}  className={`block block-${layout} ${classes ? classes : ''}`}>

				<ACFImage {...node} />

				<ACFVideo {...node} />

				<ACFWYSIWYG {...node} />

				<ACFCustom {...node} />

			</div>
		)
	}
	
	// Filter to split regular blocks and slide type blocks, so those could be grouped and thrown into slider wrapper
	const slides = props.block.filter(block => block.acf_fc_layout === 'slide')
	const blocks = props.block.filter(block => block.acf_fc_layout !== 'slide')

	// Building Blocks
	const blockMap = blocks?.map((node,i) => createBlocks(node))

	// Building Slides
	const slideMap = slides?.map((node,i) => createBlocks(node))

	// Returning Section
  return (
		<>
			{ blockMap }
			{ slideMap.length > 0 ?
				<div className="block-slider">
					<div className="slider with-aspect">
						<Slider {...sliderSettings}>
							{slideMap}
						</Slider>
					</div>
				</div>
			: null }
		</>
	)
}

export default ACFBlocks